module.exports = __webpack_public_path__ + "img/banner3.75f53ffb.png";